const getFio = (object) => {
    let fio = '';
    if (object.name_f) fio = object.name_f;
    if (object.name_i) fio += (fio === '' ? '' : ' ') + object.name_i;
    if (object.name_o) fio += (fio === '' ? '' : ' ') + object.name_o;
    return fio;
}

export default getFio;